import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Navigation APIs for locale-aware routing
 * These are wrappers around Next.js navigation that automatically handle locale
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
